/* eslint-disable */

// NB! This file is auto-generated, do not change it manually.
// In order to update it, run `make gen-client` in the backend repository.

export enum AbsenceState {
  _t = 'absences.AbsenceState',
  Approved = 'approved',
  NotApprovedYet = 'notApprovedYet',
  ReturnedForCorrection = 'returnedForCorrection'
}

export enum AbsenceTypeCategory {
  _t = 'absenceTypes.absenceTypeCategory',
  Vacation = 'vacation',
  TimeOff = 'timeOff',
  Illness = 'illness',
  Leave = 'leave',
  Other = 'other',
  EmployeesEducation = 'employeesEducation'
}

export enum AbsencesGroupByOption {
  _t = 'absences.overview.absencesGroupByOption',
  None = 'none',
  UserAccount = 'userAccount',
  UserAccountId = 'userAccountId',
  Gender = 'gender',
  AbsenceType = 'absenceType',
  Year = 'year',
  Month = 'month',
  Week = 'week',
  Day = 'day',
  Department = 'department'
}

export enum AbsencesOrderByOption {
  _t = 'absences.overview.absencesOrderByOption',
  None = 'none',
  AbsenceDateAsc = 'absenceDateAsc',
  AbsenceDateDesc = 'absenceDateDesc',
  UserAccountName = 'userAccountName',
  UserAccountId = 'userAccountId',
  AbsenceState = 'absenceState',
  AbsenceType = 'absenceType',
  AbsenceMinutesAsc = 'absenceMinutesAsc',
  AbsenceMinutesDesc = 'absenceMinutesDesc',
  Department = 'department'
}

export enum AccrualForInvoiceLine {
  _t = 'invoicingPreferences.attributes.accrualForInvoiceLine.options',
  Entity = 'entity',
  FromInvoiceMonth = 'fromInvoiceMonth',
  WithinInvoiceMonth = 'withinInvoiceMonth'
}

export enum AddToChildChecklists {
  _t = 'projects.qualitySystem.checklist.item.addToChildChecklists',
  Relevant = 'relevant',
  Irrelevant = 'irrelevant'
}

export enum AuthenticationStrategy {
  _t = 'preferences.users.authenticationStrategy',
  Sms = 'sms',
  Email = 'email',
  Otp = 'otp'
}

export enum BatchAbsenceHoursSource {
  _t = 'absences.batchAbsenceHoursSource',
  FixedHours = 'fixedHours',
  HoursFromSchedule = 'hoursFromSchedule'
}

export enum BillableTimeState {
  _t = 'enums.BillableTimeState',
  AllAsBillable = 'allAsBillable',
  NonBillableAsBillable = 'nonBillableAsBillable',
  AllAsNonBillableAndShowOnInvoice = 'allAsNonBillableAndShowOnInvoice',
  AllAsNonBillableAndNotShowOnInvoice = 'allAsNonBillableAndNotShowOnInvoice'
}

export enum BudgetColumn {
  _t = 'budget.budgetColumn',
  Income = 'income',
  IncomeHours = 'incomeHours',
  IncomeFixedPrice = 'incomeFixedPrice',
  IncomeSubscriptions = 'incomeSubscriptions',
  IncomeProducts = 'incomeProducts',
  IncomeExpenses = 'incomeExpenses',
  Cost = 'cost',
  CostSalary = 'costSalary',
  CostExpenses = 'costExpenses'
}

export enum BudgetType {
  _t = 'budget.budgetType',
  ByMonth = 'byMonth',
  ByMonthAndDepartment = 'byMonthAndDepartment',
  ByMonthAndUserAccount = 'byMonthAndUserAccount'
}

export enum CalculatedVariant {
  _t = 'projects.profitFactor.calculated.variant',
  Actual = 'actual',
  Estimated = 'estimated'
}

export enum ChecklistGroupByOption {
  _t = 'checklist.overviewReport.checklistGroupByOption',
  None = 'none',
  Customer = 'customer',
  Project = 'project',
  ProjectExtension = 'projectExtension',
  Task = 'task',
  Locked = 'locked',
  ResponsiblePerson = 'responsiblePerson',
  ControlPerson = 'controlPerson',
  TagGroup0 = 'tagGroup0',
  TagGroup1 = 'tagGroup1',
  TagGroup2 = 'tagGroup2',
  TagGroup3 = 'tagGroup3',
  TagGroup4 = 'tagGroup4'
}

export enum ChecklistOrderByOption {
  _t = 'checklist.overviewReport.checklistOrderByOption',
  None = 'none',
  CreatedDateAsc = 'createdDateAsc',
  CreatedDateDesc = 'createdDateDesc',
  ProjectNumberAsc = 'projectNumberAsc',
  ProjectNumberDesc = 'projectNumberDesc',
  CustomerNumberAsc = 'customerNumberAsc',
  CustomerNumberDesc = 'customerNumberDesc'
}

export enum ChecklistState {
  _t = 'entities.checklist.checklistState',
  InProgress = 'inProgress',
  Inactive = 'inactive',
  Finished = 'finished'
}

export enum CloudFileType {
  _t = 'cloudFileType',
  CompanyFile = 'companyFile',
  UserAccountFile = 'userAccountFile',
  ProjectFile = 'projectFile',
  ProjectNoteFile = 'projectNoteFile',
  CustomerFile = 'customerFile',
  CustomerNoteFile = 'customerNoteFile',
  ProjectEmailFile = 'projectEmailFile',
  ProjectEmailFileHtml = 'projectEmailFileHtml',
  ProjectEmailFileInlineAttachment = 'projectEmailFileInlineAttachment',
  ProjectEmailFileAttachment = 'projectEmailFileAttachment',
  InvoiceLogo = 'invoiceLogo',
  InvoiceNoteFile = 'invoiceNoteFile',
  CompanyIcon = 'companyIcon',
  CustomerIcon = 'customerIcon',
  ProjectIcon = 'projectIcon',
  UserAccountIcon = 'userAccountIcon',
  MomentLicenseInvoicePdf = 'momentLicenseInvoicePdf',
  InvoiceDraftPdf = 'invoiceDraftPdf',
  InvoicePdf = 'invoicePdf',
  InvoiceReminderPdf = 'invoiceReminderPdf',
  InvoiceDetailsPdf = 'invoiceDetailsPdf',
  InvoiceBasisPdf = 'invoiceBasisPdf',
  InvoiceDraftPdfWithDetails = 'invoiceDraftPdfWithDetails',
  InvoicePdfWithDetails = 'invoicePdfWithDetails',
  InvoiceBasisPdfWithDetails = 'invoiceBasisPdfWithDetails',
  InvoiceEhf = 'invoiceEhf',
  InvoiceAttachment = 'invoiceAttachment',
  DefaultInvoiceAttachmentForPriceDefinition = 'defaultInvoiceAttachmentForPriceDefinition',
  DefaultInvoiceAttachmentForProjectExtension = 'defaultInvoiceAttachmentForProjectExtension',
  DefaultInvoiceAttachmentForProject = 'defaultInvoiceAttachmentForProject',
  DefaultInvoiceAttachmentForCustomer = 'defaultInvoiceAttachmentForCustomer',
  DefaultInvoiceAttachmentForCompany = 'defaultInvoiceAttachmentForCompany',
  InvoicePdfWithDetailsAndAttachments = 'invoicePdfWithDetailsAndAttachments',
  InvoiceBasisPdfWithDetailsAndAttachments = 'invoiceBasisPdfWithDetailsAndAttachments',
  InvoiceFirstPaymentReminder = 'invoiceFirstPaymentReminder',
  InvoiceSecondPaymentReminder = 'invoiceSecondPaymentReminder',
  InvoicePdfsMerged = 'invoicePdfsMerged',
  InvoiceRemindersPdfMerged = 'invoiceRemindersPdfMerged',
  ToBeInvoicedReport = 'toBeInvoicedReport',
  OcrFile = 'ocrFile',
  CremulFile = 'cremulFile',
  Camt054File = 'camt054File',
  ReceiptFile = 'receiptFile',
  InvoiceExportFile = 'invoiceExportFile',
  InvoiceAdditionalExportFile = 'invoiceAdditionalExportFile',
  ExpenseAttachment = 'expenseAttachment',
  NoteAttachment = 'noteAttachment',
  VismaExpensesImport = 'vismaExpensesImport',
  VdcExpensesImport = 'vdcExpensesImport',
  CapstoneExpensesImport = 'capstoneExpensesImport',
  BorveborchseniusVismaBusinessExpensesImport = 'borveborchseniusVismaBusinessExpensesImport',
  BatchProcessTemplateFile = 'batchProcessTemplateFile',
  BatchProcessUploadFile = 'batchProcessUploadFile',
  BatchUpdateProjectUploadFile = 'batchUpdateProjectUploadFile',
  BatchUpdateCustomerUploadFile = 'batchUpdateCustomerUploadFile',
  BatchUpdateProductUploadFile = 'batchUpdateProductUploadFile',
  BatchUpdateUserAccountUploadFile = 'batchUpdateUserAccountUploadFile',
  PersonalFile = 'personalFile',
  HoursBalanceExportFile = 'hoursBalanceExportFile',
  EducationBalanceExportFile = 'educationBalanceExportFile',
  ExcelExportFile = 'excelExportFile',
  TravelAttachment = 'travelAttachment',
  ClaimPdfReport = 'claimPdfReport',
  NewsImage = 'newsImage',
  OfferPdf = 'offerPdf',
  OfferAttachment = 'offerAttachment',
  OfferDefaultAttachment = 'offerDefaultAttachment',
  OfferNoteFile = 'offerNoteFile',
  ProductSalesBatchCreateExcelFile = 'productSalesBatchCreateExcelFile',
  BudgetsBatchUpdateExcelFile = 'budgetsBatchUpdateExcelFile',
  TaskAttachment = 'taskAttachment',
  TaskScheduleAttachment = 'taskScheduleAttachment',
  CustomerLedgerExcelFile = 'customerLedgerExcelFile',
  ExcelImportExpenses = 'excelImportExpenses',
  ExcelImportChecklists = 'excelImportChecklists',
  ExcelImportBudgets = 'excelImportBudgets',
  ExcelConnectProjectExtensions = 'excelConnectProjectExtensions',
  ExcelImportAdjustments = 'excelImportAdjustments',
  HrImport = 'hrImport',
  NonconformityAttachment = 'nonconformityAttachment',
  ExportTemplate = 'exportTemplate',
  ChecklistAttachment = 'checklistAttachment',
  ContactIcon = 'contactIcon',
  RoutineAttachment = 'routineAttachment',
  VismaNetFtpExpensesImport = 'vismaNetFtpExpensesImport',
  ExpenseImportFromSocialMediaFile = 'expenseImportFromSocialMediaFile',
  FortnoxBonusReport = 'fortnoxBonusReport',
  WebhookBody = 'webhookBody',
  SignedDocument = 'signedDocument',
  OfferSignedDocument = 'offerSignedDocument',
  ProjectSignedDocument = 'projectSignedDocument',
  ResourcePlannerMonthlyReport = 'resourcePlannerMonthlyReport'
}

export enum ContactsGroupByOption {
  _t = 'contacts.groupByOption',
  None = 'none',
  Employer = 'employer',
  IsPrivate = 'isPrivate',
  IsActive = 'isActive',
  TagGroup0 = 'tagGroup0',
  TagGroup1 = 'tagGroup1',
  TagGroup2 = 'tagGroup2',
  TagGroup3 = 'tagGroup3',
  TagGroup4 = 'tagGroup4'
}

export enum ContactsOrderByOption {
  _t = 'contacts.orderByOption',
  None = 'none',
  NameAsc = 'nameAsc',
  NameDesc = 'nameDesc',
  CreatedDateAsc = 'createdDateAsc',
  CreatedDateDesc = 'createdDateDesc'
}

export enum CostCenterOption {
  _t = 'integrations.hogiaPayroll.costCenterOptions',
  DoNotIncludeCostCenter = 'doNotIncludeCostCenter',
  UseEmployeeDepartment = 'useEmployeeDepartment',
  UseProjectDepartment = 'useProjectDepartment',
  UseEmployeeTagGroup = 'useEmployeeTagGroup',
  UseProjectTagGroup = 'useProjectTagGroup'
}

export enum CustomFieldEntity {
  _t = 'entities.customField.customFieldEntity',
  Customer = 'customer',
  Project = 'project',
  Task = 'task',
  UserAccount = 'userAccount',
  ProjectExtension = 'projectExtension'
}

export enum CustomFieldType {
  _t = 'entities.customField.customFieldType',
  Currency = 'currency',
  CurrencyPositive = 'currencyPositive',
  CurrencyNonNegative = 'currencyNonNegative',
  Decimal = 'decimal',
  DecimalPositive = 'decimalPositive',
  DecimalNonNegative = 'decimalNonNegative',
  Integer = 'integer',
  IntegerPositive = 'integerPositive',
  IntegerNonNegative = 'integerNonNegative',
  StringLine = 'stringLine',
  StringText = 'stringText',
  Bool = 'bool',
  Date = 'date',
  ExternalUrl = 'externalUrl'
}

export enum CustomerClassification {
  _t = 'customers.customerClassification',
  Company = 'company',
  PrivatePerson = 'privatePerson'
}

export enum CustomerNumberSeriesHandling {
  _t = 'customers.customerNumberSeriesHandling',
  Internal = 'internal',
  External = 'external'
}

export enum CustomerState {
  _t = 'customers.customerState',
  Potential = 'potential',
  Active = 'active',
  Blocked = 'blocked',
  Inactive = 'inactive'
}

export enum CustomerType {
  _t = 'customers.customersTypes',
  IsCustomer = 'isCustomer',
  IsSubcontractor = 'isSubcontractor',
  IsOurself = 'isOurself',
  IsSupplier = 'isSupplier'
}

export enum DailyAllowanceFieldType {
  _t = 'travel.claims.expenses.dailyAllowance',
  Breakfast = 'breakfast',
  Lunch = 'lunch',
  Dinner = 'dinner',
  Night = 'night',
  WholeDay = 'wholeDay'
}

export enum DataSource {
  _t = 'overviewReport.dataSource',
  WebApi = 'webApi',
  SelfSignup = 'selfSignup',
  ImportApi = 'importApi',
  Integration = 'integration',
  Internal = 'internal',
  Migration = 'migration',
  PartnerApi = 'partnerApi',
  Manual = 'manual',
  Mobile = 'mobile',
  Testdata = 'testdata',
  Lundatech = 'lundatech'
}

export enum DateFormatting {
  _t = 'dateTimeUtils.attributes.dateFormats.options',
  DmyDot = 'dmy_dot',
  YmdDot = 'ymd_dot',
  DmySlash = 'dmy_slash',
  MdySlash = 'mdy_slash',
  SsDash = 'ss_dash',
  MdyDash = 'mdy_dash'
}

export enum DefaultProjectOwnerOption {
  _t = 'preferences.projects.defaultProjectOwnerOption',
  Manual = 'manual',
  ProjectCreator = 'projectCreator',
  ProjectMembershipRole = 'projectMembershipRole'
}

export enum DepartmentImport {
  _t = 'ipaas.config.departmentImport',
  Disabled = 'disabled',
  Department = 'department',
  Tag = 'tag'
}

export enum DepartmentOption {
  _t = 'integrations.departmentOption',
  Department = 'department',
  TagGroup = 'tagGroup'
}

export enum DocumentStatus {
  _t = 'scriveDocument.documentStatus',
  Preparation = 'preparation',
  AwaitingStart = 'awaiting_start',
  Pending = 'pending',
  Closed = 'closed',
  Canceled = 'canceled',
  Timedout = 'timedout',
  Rejected = 'rejected',
  DocumentError = 'document_error'
}

export enum DraftDeleteDisposition {
  _t = 'entities.draftDeleteDisposition',
  RevertToBillable = 'revertToBillable',
  KeepInvoiced = 'keepInvoiced',
  NotBillable = 'notBillable'
}

export enum DynamicInvoiceLineDepartmentOption {
  _t = 'integrations.listview.views.dynamic.invoiceLineDepartmentOption',
  DontExportDepartment = 'dontExportDepartment',
  UseResourceDepartment = 'useResourceDepartment',
  UseResourceTagGroup = 'useResourceTagGroup'
}

export enum EducationPoolType {
  _t = 'settings.educationFunds.educationPoolType',
  CommonPool = 'commonPool',
  IndividualPool = 'individualPool'
}

export enum EmploymentCompensationType {
  _t = 'users.employmentCompensationType',
  Salaried = 'salaried',
  Hourly = 'hourly'
}

export enum EmploymentCompensationTypeOption {
  _t = 'users.employmentCompensationType',
  Salaried = 'salaried',
  Hourly = 'hourly',
  All = 'all'
}

export enum EmploymentType {
  _t = 'users.employmentTypes',
  Fulltime = 'fulltime',
  Parttime = 'parttime',
  Trainee = 'trainee',
  Substitute = 'substitute',
  Temporary = 'temporary',
  Freelancer = 'freelancer',
  Retiree = 'retiree'
}

export enum EventType {
  _t = 'notification.calendarImports.EventType',
  Focus = 'focus',
  Huddle = 'huddle',
  Meeting = 'meeting',
  OutOfOffice = 'outOfOffice',
  Other = 'other'
}

export enum ExpenseAttachmentPolicy {
  _t = 'ipaas.config.expenseAttachmentPolicy',
  NoAdditionalAttachments = 'noAdditionalAttachments',
  AllowedBeforeInvoiced = 'allowedBeforeInvoiced',
  AllowedAfterInvoiced = 'allowedAfterInvoiced'
}

export enum ExpenseLinesGroupByOption {
  _t = 'invoicingPreferences.attributes.expenseLinesGroupByOption.options',
  None = 'none',
  Activity = 'activity'
}

export enum ExportExpenseDepartmentOption {
  _t = 'integrations.listview.views.exportExpenseDepartmentOption',
  DontExportDepartment = 'dontExportDepartment',
  UseProjectTagGroup = 'useProjectTagGroup',
  UseProjectDepartment = 'useProjectDepartment',
  UseUserDepartment = 'useUserDepartment',
  UseUserTagGroup = 'useUserTagGroup'
}

export enum ExportFileType {
  _t = 'export.fileType',
  Txt = 'txt',
  Csv = 'csv',
  Html = 'html',
  Xhtml = 'xhtml',
  Xml = 'xml',
  Rtf = 'rtf',
  Hlw = 'hlw',
  Si = 'si',
  Dta = 'dta',
  Tlu = 'tlu'
}

export enum ExportInvoiceAttachmentOption {
  _t = 'ipaas.config.exportInvoiceAttachmentOption',
  InvoicePdf = 'invoicePdf',
  InvoicePdfWithDetails = 'invoicePdfWithDetails',
  InvoicePdfWithDetailsAndAttachments = 'invoicePdfWithDetailsAndAttachments'
}

export enum ExportInvoiceDepartmentOption {
  _t = 'integrations.listview.views.exportInvoiceDepartmentOption',
  DontExportDepartment = 'dontExportDepartment',
  UseAccountingDepartment = 'useAccountingDepartment',
  UseInvoiceDepartment = 'useInvoiceDepartment',
  UseProjectTagGroup = 'useProjectTagGroup',
  UseProjectDepartment = 'useProjectDepartment',
  UseInvoiceTagGroup = 'useInvoiceTagGroup'
}

export enum ExportInvoiceLineDepartmentOption {
  _t = 'integrations.listview.views.exportInvoiceLineDepartmentOption',
  DontExportDepartment = 'dontExportDepartment',
  UseProjectTagGroup = 'useProjectTagGroup',
  UseProjectDepartment = 'useProjectDepartment',
  UseUserDepartment = 'useUserDepartment',
  UseUserTagGroup = 'useUserTagGroup',
  UseInvoiceDepartment = 'useInvoiceDepartment',
  UseInvoiceTagGroup = 'useInvoiceTagGroup'
}

export enum ExportProjectDepartmentOption {
  _t = 'integrations.listview.views.exportProjectDepartmentOption',
  DontExportDepartment = 'dontExportDepartment',
  UseProjectDepartment = 'useProjectDepartment',
  UseProjectTagGroup = 'useProjectTagGroup'
}

export enum FileStorageLocation {
  _t = 'customers.fileStorageLocations',
  MomentCloud = 'momentCloud',
  Sharepoint = 'sharepoint',
  Inherited = 'inherited'
}

export enum FileType {
  _t = 'fileType',
  Document = 'Document',
  Spreadsheet = 'Spreadsheet',
  Presentation = 'Presentation',
  Image = 'Image',
  Email = 'Email',
  Text = 'Text',
  Audio = 'Audio',
  Video = 'Video',
  Archive = 'Archive'
}

export enum FilterMode {
  _t = 'filterMode',
  OnlyPersonal = 'onlyPersonal',
  OnlyCompany = 'onlyCompany'
}

export enum FilterType {
  _t = 'filterType',
  TimeRecords = 'timeRecords',
  Invoices = 'invoices',
  Expenses = 'expenses',
  Absences = 'absences',
  ProjectRegisteredHoursReport = 'projectRegisteredHoursReport',
  Projects = 'projects',
  PlannedPayments = 'plannedPayments',
  ToBeInvoiced = 'toBeInvoiced',
  MoneyTransactions = 'moneyTransactions',
  Tasks = 'tasks',
  ProductSales = 'productSales',
  Customers = 'customers',
  Contacts = 'contacts',
  Subscriptions = 'subscriptions',
  Claims = 'claims',
  Nonconformities = 'nonconformities',
  Review = 'review',
  Users = 'users',
  Offers = 'offers',
  InvoicesLine = 'invoicesLine',
  Overtimes = 'overtimes',
  TaskStatusOverview = 'taskStatusOverview',
  AdminCompanies = 'adminCompanies',
  AdminCompanyContacts = 'adminCompanyContacts',
  ProjectExtensions = 'projectExtensions',
  CompanyForecast = 'companyForecast',
  Risks = 'risks',
  Checklist = 'checklist'
}

export enum FixedPriceBase {
  _t = 'priceDefinitions.fixedPriceBases',
  PaymentPlan = 'paymentPlan',
  ProductSales = 'productSales',
  ProjectExtension = 'projectExtension'
}

export enum Gender {
  _t = 'users.genders',
  Female = 'female',
  Male = 'male',
  Other = 'other',
  NotSet = 'notSet'
}

export enum GeocodeState {
  _t = 'geocodeState',
  Updated = 'updated',
  ZeroResults = 'zeroResults',
  Expired = 'expired',
  Manual = 'manual'
}

export enum GroupByOption {
  _t = 'integrations.hogiaPayroll.groupByOptions',
  DoNotGroup = 'doNotGroup',
  Project = 'project',
  CostCenter = 'costCenter'
}

export enum HourlyRateBase {
  _t = 'priceDefinitions.hourlyRateBases',
  None = 'none',
  UserAccounts = 'userAccounts',
  ProjectMembershipRoles = 'projectMembershipRoles',
  PriceDefinitionsDefaultHourlyRates = 'priceDefinitionsDefaultHourlyRates',
  Customer = 'customer',
  HourlyRateGroup = 'hourlyRateGroup',
  UserAccountTotalCost = 'userAccountTotalCost',
  UserAccountSalary = 'userAccountSalary',
  BasedOnOffer = 'basedOnOffer',
  Partner = 'partner'
}

export enum HourlyRateGroupType {
  _t = 'entities.hourlyRateGroup.hourlyRateGroupType',
  Company = 'company',
  Customer = 'customer'
}

export enum HoursInvoiceLinesGroupByOption {
  _t = 'invoicingPreferences.attributes.hoursInvoiceLinesGroupByOption.options',
  OneLine = 'oneLine',
  UserAccount = 'userAccount',
  Activity = 'activity',
  UserAccountAndActivity = 'userAccountAndActivity',
  UserAccountAndMembershipRole = 'userAccountAndMembershipRole',
  ActivityAndUserAccount = 'activityAndUserAccount',
  ProjectMembershipRole = 'projectMembershipRole',
  Task = 'task'
}

export enum IPaasInvoiceSendingType {
  _t = 'ipaas.config.exportInvoiceType',
  Posting = 'posting',
  Invoice = 'invoice',
  Draft = 'draft'
}

export enum ImportActivity {
  _t = 'ipaas.config.importActivity',
  CreateFromEntity = 'createFromEntity',
  CreateWithDefaultName = 'createWithDefaultName'
}

export enum ImportBillable {
  _t = 'ipaas.config.importBillable',
  FromEntity = 'fromEntity',
  FromActivityPriceModel = 'fromActivityPriceModel',
  FromDefaultSetting = 'fromDefaultSetting'
}

export enum ImportExpenseCategory {
  _t = 'ipaas.config.importExpenseCategory',
  Disabled = 'disabled',
  DefaultExpenseCategory = 'defaultExpenseCategory',
  Posting = 'posting'
}

export enum ImportFinancialAccount {
  _t = 'ipaas.config.importFinancialAccount',
  PriceModel = 'priceModel',
  DefaultFinancialAccount = 'defaultFinancialAccount',
  Posting = 'posting',
  CompanyDefaultConfiguration = 'companyDefaultConfiguration'
}

export enum ImportPaymentType {
  _t = 'ipaas.config.importPaymentType',
  FullyPaid = 'fullyPaid',
  PartiallyPaid = 'partiallyPaid'
}

export enum ImportResourceLink {
  _t = 'ipaas.config.importResourceLink',
  Email = 'email',
  ExternalEmployeeNumber = 'externalEmployeeNumber'
}

export enum ImportStatus {
  _t = 'integrations.calendarImport',
  NewRecord = 'newRecord',
  TimeRecordCreated = 'timeRecordCreated',
  Disregarded = 'disregarded'
}

export enum ImportSurcharge {
  _t = 'ipaas.config.importSurcharge',
  Disabled = 'disabled',
  DefaultSurcharge = 'defaultSurcharge',
  FromActivityPriceModel = 'fromActivityPriceModel'
}

export enum ImportUserAccount {
  _t = 'ipaas.config.importUserAccount',
  Disabled = 'disabled',
  ProjectOwner = 'projectOwner',
  DepartmentManager = 'departmentManager',
  FromEntity = 'fromEntity'
}

export enum IncludeDepartmentOption {
  _t = 'integrations.includeDepartmentOption',
  Project = 'project',
  Resource = 'resource'
}

export enum IncludeInProjects {
  _t = 'companyRoutines.includeRoutine',
  NoProjects = 'noProjects',
  NewProjects = 'newProjects',
  NewAndExistingProjects = 'newAndExistingProjects'
}

export enum Industry {
  _t = 'company.industries',
  Accounting = 'accounting',
  Architect = 'architect',
  Engineer = 'engineer',
  Creative = 'creative',
  Lawyer = 'lawyer',
  Tech = 'tech',
  Consultant = 'consultant',
  Other = 'other'
}

export enum IntegrationType {
  _t = 'integrationPreferences',
  VismaServicePlatform = 'VismaServicePlatform',
  Fiken = 'Fiken',
  Fiken2 = 'Fiken2',
  Jira = 'Jira',
  Maks10 = 'Maks10',
  PowerOfficeGo = 'PowerOfficeGo',
  Ocr = 'OCR',
  Maventa = 'Maventa',
  Tripletex = 'Tripletex',
  TripletexPayments = 'TripletexPayments',
  Cascade = 'Cascade',
  Xledger = 'Xledger',
  SevenOffice24 = 'SevenOffice24',
  Fortnox = 'Fortnox',
  FortnoxPayments = 'FortnoxPayments',
  UniEconomy = 'UniEconomy',
  DnbRegnskap = 'DnbRegnskap',
  Sparebank1 = 'Sparebank1',
  VismaDocumentCenter = 'VismaDocumentCenter',
  MomentAnalytics = 'MomentAnalytics',
  WebhookCustomers = 'WebhookCustomers',
  WebhookProjects = 'WebhookProjects',
  WebhookProjectMemberships = 'WebhookProjectMemberships',
  WebhookInvoices = 'WebhookInvoices',
  WebhookClaims = 'WebhookClaims',
  WebhookOffersWhenStateChanges = 'WebhookOffersWhenStateChanges',
  WebhookAcceptedOrDeclinedOffers = 'WebhookAcceptedOrDeclinedOffers',
  Economic = 'Economic',
  EconomicPayments = 'EconomicPayments',
  CloudwareInternalMailChimp = 'CloudwareInternalMailChimp',
  InExchange = 'InExchange',
  Ambita = 'Ambita',
  Dynamic = 'Dynamic',
  RecMan = 'RecMan',
  Scrive = 'Scrive',
  Holte = 'Holte',
  GoogleAds = 'GoogleAds',
  FacebookAds = 'FacebookAds',
  SnapchatAds = 'SnapchatAds',
  LinkedinAds = 'LinkedinAds',
  Dv360 = 'Dv360',
  MicrosoftAds = 'MicrosoftAds',
  VismaNetFtp = 'VismaNetFtp',
  AddMobile = 'AddMobile',
  TidBank = 'TidBank',
  PeppolBilling3 = 'PeppolBilling3',
  NetsOcrCremul = 'NetsOcrCremul',
  FileExport = 'FileExport',
  ApiAccess = 'ApiAccess',
  HogiaPayroll = 'HogiaPayroll',
  Sharepoint = 'Sharepoint',
  Dk = 'DK',
  ProjectHelp = 'ProjectHelp',
  BusinessCentral = 'BusinessCentral',
  BusinessCentralPayments = 'BusinessCentralPayments',
  BusinessCentralExpenses = 'BusinessCentralExpenses',
  CatalystOne = 'CatalystOne',
  ProjectOnline = 'ProjectOnline',
  Younium = 'Younium',
  SsoMicrosoft = 'SsoMicrosoft',
  Unknown = 'Unknown',
  ExportToAccountor = 'ExportToAccountor',
  ExportToC5 = 'ExportToC5',
  ExportToNordeaFactoring = 'ExportToNordeaFactoring',
  ExportToSgfinans = 'ExportToSgfinans',
  ExportToSgfinansXml = 'ExportToSgfinansXml',
  ExportToDuettMamut = 'ExportToDuettMamut',
  ExportToNavision = 'ExportToNavision',
  ExportToRegla = 'ExportToRegla',
  ExportToSparebank1Factoring = 'ExportToSparebank1Factoring',
  ExportToVismaDiSystems = 'ExportToVismaDiSystems',
  ExportToVismaNet = 'ExportToVismaNet',
  ExportToDuett = 'ExportToDuett',
  ExportToUniEconomy = 'ExportToUniEconomy',
  ExportToXledger = 'ExportToXledger',
  ExportToXledgerGL02b = 'ExportToXledgerGL02b',
  ExportToVismaGlobal = 'ExportToVismaGlobal',
  ExportToUniMicro = 'ExportToUniMicro',
  ExportToVismaBusiness = 'ExportToVismaBusiness',
  ExportToVismaScenario = 'ExportToVismaScenario',
  ExportToMamut = 'ExportToMamut',
  ExportToPAXml = 'ExportToPAXml',
  ExportToFortnoxPAXml = 'ExportToFortnoxPAXml',
  ExportToTemplate = 'ExportToTemplate',
  ExportToTemplate2 = 'ExportToTemplate2',
  ExportToTemplate3 = 'ExportToTemplate3',
  Simployer = 'Simployer',
  CalendarImport = 'CalendarImport',
  Uniconta = 'Uniconta',
  UnicontaPayments = 'UnicontaPayments'
}

export enum InvoiceEmailRecipientType {
  _t = 'contacts.invoiceEmailRecipientType',
  To = 'to',
  Cc = 'cc',
  Bcc = 'bcc',
  None = 'none'
}

export enum InvoiceLineType {
  _t = 'invoices.invoiceLineTypes',
  FixedPrice = 'fixedPrice',
  Hours = 'hours',
  Expense = 'expense',
  Product = 'product',
  AdministrationCosts = 'administrationCosts',
  DeductionForSplit = 'deductionForSplit',
  PaymentInAdvance = 'paymentInAdvance',
  Rounding = 'rounding'
}

export enum InvoiceLinesGroupByOption {
  _t = 'invoicingPreferences.attributes.invoiceLinesGroupByOption.options',
  None = 'none',
  InvoiceLineType = 'invoiceLineType',
  ProjectExtension = 'projectExtension'
}

export enum InvoiceLinesOrderByOption {
  _t = 'invoicesLine.overviewReport.invoiceLinesOrderByOption',
  None = 'none',
  InvoiceLineType = 'invoiceLineType',
  LineNumberAsc = 'lineNumberAsc',
  LineNumberDesc = 'lineNumberDesc',
  InvoiceNumberAsc = 'invoiceNumberAsc',
  InvoiceNumberDesc = 'invoiceNumberDesc',
  QuantityAsc = 'quantityAsc',
  QuantityDesc = 'quantityDesc',
  SumNetAmountAsc = 'sumNetAmountAsc',
  SumNetAmountDesc = 'sumNetAmountDesc',
  ProjectDepartment = 'projectDepartment',
  ProjectName = 'projectName',
  ProjectNumber = 'projectNumber',
  ProjectOwners = 'projectOwners',
  CustomerName = 'customerName',
  CustomerNumber = 'customerNumber',
  DueDateAsc = 'dueDateAsc',
  DueDateDesc = 'dueDateDesc',
  IssueDateAsc = 'issueDateAsc',
  IssueDateDesc = 'issueDateDesc',
  CurrencyCode = 'currencyCode'
}

export enum InvoiceLinesReportGroupByOption {
  _t = 'invoicesLine.overviewReport.invoiceLinesGroupByOption',
  None = 'none',
  Invoice = 'invoice',
  InvoiceLineType = 'invoiceLineType',
  CurrencyCode = 'currencyCode',
  Project = 'project',
  ProjectExtension = 'projectExtension',
  ProjectDepartment = 'projectDepartment',
  ProjectOwner = 'projectOwner',
  Customer = 'customer',
  Month = 'month',
  Year = 'year',
  FinancialAccount = 'financialAccount',
  PeriodStartMonth = 'periodStartMonth',
  PeriodEndMonth = 'periodEndMonth',
  InvoiceIssueDateMonth = 'invoiceIssueDateMonth',
  Product = 'product',
  ProductGroup = 'productGroup'
}

export enum InvoicePriceDefinitionTotalsHoursVisibilityOption {
  _t = 'invoicingPreferences.attributes.invoicePriceDefinitionTotalsHoursVisibilityOption.options',
  DontShow = 'dontShow',
  ShowOnlyForActivities = 'showOnlyForActivities',
  ShowAlways = 'showAlways'
}

export enum InvoicePriceDefinitionTotalsPlacementOption {
  _t = 'invoicingPreferences.attributes.invoicePriceDefinitionTotalsPlacementOption',
  BeforeInvoiceLines = 'beforeInvoiceLines',
  AfterInvoiceLines = 'afterInvoiceLines'
}

export enum InvoicePriceDefinitionTotalsVisibilityOption {
  _t = 'invoicingPreferences.attributes.invoicePriceDefinitionTotalsVisibilityOption.options',
  DontShow = 'dontShow',
  ShowWhenTotalPriceIsSet = 'showWhenTotalPriceIsSet',
  ShowAlways = 'showAlways'
}

export enum InvoiceStateFilter {
  _t = 'invoices.overview.invoiceStateFilter',
  Draft = 'draft',
  Finished = 'finished',
  ReadyForApproval = 'readyForApproval',
  Paid = 'paid',
  Unpaid = 'unpaid',
  Overdue = 'overdue'
}

export enum InvoiceSummaryLines {
  _t = 'invoicingPreferences.attributes.InvoiceSummaryLines.options',
  TotalPrice = 'totalPrice',
  PreviouslyInvoiced = 'previouslyInvoiced',
  InvoicedInCurrentInvoice = 'invoicedInCurrentInvoice',
  TotallyInvoicedUntilNow = 'totallyInvoicedUntilNow',
  RemainingToInvoice = 'remainingToInvoice'
}

export enum InvoiceTimeRecordsGroupByOption {
  _t = 'invoicingPreferences.attributes.invoiceTimeRecordsGroupByOption.options',
  ActivityAndUserAccount = 'activityAndUserAccount',
  ActivityAndTask = 'activityAndTask',
  ActivityAndProjectMembershipRole = 'activityAndProjectMembershipRole',
  UserAccount = 'userAccount',
  Activity = 'activity',
  ProjectMembershipRole = 'projectMembershipRole'
}

export enum InvoiceType {
  _t = 'invoices.overview.invoiceType',
  Invoice = 'invoice',
  CreditNote = 'creditNote'
}

export enum InvoicedState {
  _t = 'entities.invoicedState',
  NotApprovedForInvoicing = 'notApprovedForInvoicing',
  ApprovedForInvoicing = 'approvedForInvoicing',
  ReturnedForCorrection = 'returnedForCorrection',
  Invoiced = 'invoiced'
}

export enum InvoicesState {
  _t = 'customers.views.InvoicesState',
  NoInvoices = 'noInvoices',
  HasInvoices = 'hasInvoices',
  HasInvoicesInLastYear = 'hasInvoicesInLastYear',
  HasUnpaidInvoices = 'hasUnpaidInvoices',
  HasOverdueInvoices = 'hasOverdueInvoices'
}

export enum InvoicingPreferencesScope {
  _t = 'invoicingPreferences.scope',
  Global = 'global',
  Company = 'company',
  Customer = 'customer',
  Department = 'department',
  Project = 'project',
  PriceDefinition = 'priceDefinition',
  AdditionalCustomer = 'additionalCustomer',
  ProjectExtension = 'projectExtension'
}

export enum JsonReportColumnType {
  _t = 'reports.columnType',
  Address = 'address',
  Currency = 'currency',
  CurrencyWithCode = 'currencyWithCode',
  Date = 'date',
  DateTime = 'dateTime',
  ToDateOrCurrent = 'toDateOrCurrent',
  NextInvoiceDateOrExpired = 'nextInvoiceDateOrExpired',
  MonthsCount = 'monthsCount',
  Departments = 'departments',
  Tags = 'tags',
  TagItem = 'tagItem',
  InvoicedState = 'invoicedState',
  AbsenceState = 'absenceState',
  EvaluationType = 'evaluationType',
  Rating = 'rating',
  ProjectExtensionState = 'projectExtensionState',
  ProjectState = 'projectState',
  OvertimePaymentStatus = 'overtimePaymentStatus',
  MoneyTransactionType = 'moneyTransactionType',
  Gender = 'gender',
  Industry = 'industry',
  SubscriptionType = 'subscriptionType',
  AdminCompanyWarningType = 'adminCompanyWarningType',
  CustomField = 'customField',
  MinutesToHours = 'minutesToHours',
  MinutesToHoursWithGroupPercentage = 'minutesToHoursWithGroupPercentage',
  Invoices = 'invoices',
  ProjectExtensions = 'projectExtensions',
  ProjectOwners = 'projectOwners',
  UserNames = 'userNames',
  NumberWithPrefix = 'numberWithPrefix',
  NumberWithSuffix = 'numberWithSuffix',
  NumberAndNameAsList = 'numberAndNameAsList',
  ChecklistItem = 'checklistItem',
  TitleValue = 'titleValue',
  TaskChecklists = 'taskChecklists',
  Percentage = 'percentage',
  TransferState = 'transferState',
  SendingState = 'sendingState',
  SendingMethod = 'sendingMethod',
  InvoiceNumberOrDraft = 'invoiceNumberOrDraft',
  OutstandingAmountOrState = 'outstandingAmountOrState',
  CurrencyOrCompanyCurrency = 'currencyOrCompanyCurrency',
  PaidDateUnlessCredited = 'paidDateUnlessCredited',
  DaysBetweenUnlessCredited = 'daysBetweenUnlessCredited',
  DelayedInvoicingUntilDateOrIndefinite = 'delayedInvoicingUntilDateOrIndefinite',
  Customer = 'customer',
  Customers = 'customers',
  Projects = 'projects',
  Emails = 'emails',
  YesNo = 'yesNo',
  ClaimStatus = 'claimStatus',
  ClaimType = 'claimType',
  CustomerState = 'customerState',
  CustomerTypes = 'customerTypes',
  Country = 'country',
  CustomerInvoiceEmails = 'customerInvoiceEmails',
  OfferState = 'offerState',
  Bool = 'bool',
  DateRange = 'dateRange',
  Attachments = 'attachments',
  NonconformityImpactLevel = 'nonconformityImpactLevel',
  ActionType = 'actionType',
  ClosedState = 'closedState',
  ProjectMembershipRoles = 'projectMembershipRoles',
  ContentClass = 'contentClass',
  SubscriptionInvoicingType = 'subscriptionInvoicingType',
  SubscriptionInvoicingTypeWithDays = 'subscriptionInvoicingTypeWithDays',
  Compensation = 'compensation',
  TaskState = 'taskState',
  TaskNumber = 'taskNumber',
  RoutineNumbers = 'routineNumbers',
  TaskMembershipUserNames = 'taskMembershipUserNames',
  Nationality = 'nationality',
  EmploymentType = 'employmentType',
  EmploymentCompensationType = 'employmentCompensationType',
  CanLogIn = 'canLogIn',
  InternalExternal = 'internalExternal',
  CurrentlyHired = 'currentlyHired',
  FollowupTasks = 'followupTasks',
  FinancialAccount = 'financialAccount'
}

export enum Languages {
  _t = 'languagesService.languages',
  En = 'en',
  Da = 'da',
  Is = 'is',
  Sv = 'sv',
  Fi = 'fi',
  Nb = 'nb',
  De = 'de',
  Fr = 'fr'
}

export enum LastDayToApproveHours {
  _t = 'preferences.users.lastDayToApproveHoursEnum',
  LastDayOfPreviousMonth = 'lastDayOfPreviousMonth',
  FridayOfPreviousWeek = 'fridayOfPreviousWeek',
  SundayOfPreviousWeek = 'sundayOfPreviousWeek'
}

export enum LetterMargins {
  _t = 'invoicingPreferences.attributes.letterMargins.options',
  Norway = 'norway',
  Sweden = 'sweden'
}

export enum LocalCodeLanguages {
  _t = 'languagesService.localCodeLanguages',
  DaDk = 'da_DK',
  EnUs = 'en_US',
  FiFi = 'fi_FI',
  IsIs = 'is_IS',
  NbNo = 'nb_NO',
  SvSe = 'sv_SE'
}

export enum MileageClaimPeriod {
  _t = 'travel.claims.mileagePeriod.',
  Month = 'month',
  Day = 'day'
}

export enum MinutesToHoursFormattingOption {
  _t = 'preferences.formatting.minutesToHours',
  TimeString = 'timeString',
  TimeStringTextFormat = 'timeStringTextFormat',
  DecimalHours = 'decimalHours',
  IntegerHours = 'integerHours'
}

export enum MomentAnalyticsReports {
  _t = 'integrations.integrationTypes.MomentAnalytics',
  FinancialDevelopment = 'financialDevelopment',
  ProjectFinances = 'projectFinances',
  ProjectForecast = 'projectForecast',
  Resources = 'resources',
  ResourcesForecast = 'resourcesForecast',
  Employees = 'employees',
  Projects = 'projects',
  InvoiceFollowUp = 'invoiceFollowUp',
  FixedPrice = 'fixedPrice',
  DepartmentsOverview = 'departmentsOverview',
  Absences = 'absences',
  Tasks = 'tasks',
  Products = 'products',
  Nonconformities = 'nonconformities',
  TimeRecords = 'timeRecords',
  Expenses = 'expenses',
  Punctuality = 'punctuality',
  Info = 'info'
}

export enum MomentPlan {
  _t = 'company.momentPlans',
  Start = 'Start',
  Essential = 'Essential',
  Pro = 'Pro',
  Quality = 'Quality'
}

export enum MyProjects {
  _t = 'projects.overview.myProjects',
  All = 'all',
  Mine = 'mine',
  Favorites = 'favorites',
  IProjectOwner = 'iProjectOwner'
}

export enum NonconformityImpactLevel {
  _t = 'projects.qualitySystem.nonconformities.impact',
  Low = 'low',
  Medium = 'medium',
  High = 'high'
}

export enum NotificationEventType {
  _t = 'preferences.notifications',
  TimeLockDelayed = 'timeLockDelayed',
  PaymentReceived = 'paymentReceived',
  TaskAssigned = 'taskAssigned',
  TaskUnassigned = 'taskUnassigned',
  TaskOwnerAssigned = 'taskOwnerAssigned',
  TaskOwnerUnassigned = 'taskOwnerUnassigned',
  TaskDueDate = 'taskDueDate',
  ActivityDueDate = 'activityDueDate',
  BankAccountNumberChanged = 'bankAccountNumberChanged',
  NonconformityResponsibleUser = 'nonconformityResponsibleUser',
  NonconformityClosingUser = 'nonconformityClosingUser',
  ChecklistResponsibleUser = 'checklistResponsibleUser',
  ChecklistControlUser = 'checklistControlUser',
  ProjectChecklistCompleted = 'projectChecklistCompleted',
  ProjectChecklistControlled = 'projectChecklistControlled',
  ProjectChecklistChanged = 'projectChecklistChanged',
  OfferAcceptedUser = 'offerAcceptedUser',
  OfferAcceptedCreator = 'offerAcceptedCreator',
  OfferDeclined = 'offerDeclined',
  OfferDeleted = 'offerDeleted',
  Note = 'note',
  NoteForInvoice = 'noteForInvoice',
  NoteForProject = 'noteForProject',
  NoteForCustomer = 'noteForCustomer',
  NoteForProjectRevision = 'noteForProjectRevision',
  NoteForTask = 'noteForTask',
  NoteForOffer = 'noteForOffer',
  NoteForCompanyMainFeed = 'noteForCompanyMainFeed',
  NoteForNonconformity = 'noteForNonconformity',
  ProjectAssigned = 'projectAssigned',
  ProjectUnassigned = 'projectUnassigned',
  ProjectDeleted = 'projectDeleted',
  Reminder = 'reminder',
  TaskReminder = 'taskReminder',
  NoteReminder = 'noteReminder',
  ProjectReminder = 'projectReminder',
  NotifyRoutineUsers = 'notifyRoutineUsers',
  RegularReminder = 'regularReminder',
  NotifyAbsenceApproved = 'notifyAbsenceApproved',
  TravelAndExpenseToBeReviewed = 'travelAndExpenseToBeReviewed',
  TravelAndExpenseToBeRefunded = 'travelAndExpenseToBeRefunded',
  TravelAndExpenseApproved = 'travelAndExpenseApproved',
  TravelAndExpenseRejected = 'travelAndExpenseRejected',
  TravelAndExpensePaidOut = 'travelAndExpensePaidOut',
  TimeRecordCalendarImportNewRecords = 'timeRecordCalendarImportNewRecords',
  PaymentsUpdated = 'paymentsUpdated',
  PaymentReminderSendFailed = 'paymentReminderSendFailed',
  NewProductAdded = 'newProductAdded',
  MissingCustomer = 'missingCustomer',
  Churn = 'churn',
  PlanChanged = 'planChanged',
  SupportAccessRequest = 'supportAccessRequest',
  SupportAccessGranted = 'supportAccessGranted',
  MobileType = 'mobileType'
}

export enum NotificationMethod {
  _t = 'notificationSubscriptions.notificationMethod',
  UserInterface = 'userInterface',
  Email = 'email',
  Mobile = 'mobile',
  None = 'none'
}

export enum NotificationTypeOnOverworking {
  _t = 'preferences.projects.notificationTypeOnOverworkingOption',
  None = 'none',
  ShowAlertAndAllowOverworking = 'showAlertAndAllowOverworking',
  ShowAlertAndDisallowOverworking = 'showAlertAndDisallowOverworking'
}

export enum OfferState {
  _t = 'offers.offerState',
  Draft = 'draft',
  Ready = 'ready',
  Sent = 'sent',
  Accepted = 'accepted',
  Declined = 'declined'
}

export enum PAXmlBankedHoursExportOption {
  _t = 'integrations.paxml.bankedHoursExportOption',
  Transactions = 'transactions',
  Summarized = 'summarized'
}

export enum PAXmlExportType {
  _t = 'integrations.paxml.exportType',
  TimeRecords = 'timeRecords',
  SalaryData = 'salaryData',
  TimeRecordsAndSalaryData = 'timeRecordsAndSalaryData'
}

export enum PAXmlIncludeResourcesInformationOption {
  _t = 'integrations.paxml.includeResourcesInformationOption',
  Always = 'always',
  HasTransactions = 'hasTransactions'
}

export enum PAXmlIncludeResourcesStatusOption {
  _t = 'integrations.paxml.includeResourcesStatusOption',
  OnlyActive = 'onlyActive',
  All = 'all'
}

export enum PAXmlIncludeResourcesTypeOption {
  _t = 'integrations.paxml.includeResourcesTypeOption',
  OnlyInternal = 'onlyInternal',
  All = 'all'
}

export enum ParticipantEntityType {
  _t = 'scriveDocumentParticipant.participantEntityType',
  UserAccount = 'userAccount',
  Contact = 'contact'
}

export enum PeriodType {
  _t = 'overviewReport.periodType',
  None = 'none',
  All = 'all',
  CurrentDay = 'currentDay',
  Last7Days = 'last7Days',
  Last100Days = 'last100Days',
  PreviousWeek = 'previousWeek',
  CurrentWeek = 'currentWeek',
  PreviousMonth = 'previousMonth',
  CurrentMonth = 'currentMonth',
  PreviousYear = 'previousYear',
  CurrentYear = 'currentYear',
  UntilEndPreviousMonth = 'untilEndPreviousMonth',
  UntilCurrentDay = 'untilCurrentDay'
}

export enum PlaceholderValue {
  _t = 'changeLog.contentPlaceholder',
  PlaceholderHtmlOldValue = 'placeholder_html_old_value',
  PlaceholderHtmlNewValue = 'placeholder_html_new_value',
  PlaceholderMarkdownOldValue = 'placeholder_markdown_old_value',
  PlaceholderMarkdownNewValue = 'placeholder_markdown_new_value'
}

export enum PriceModel {
  _t = 'priceDefinitions.priceModel',
  NotBillable = 'notBillable',
  FixedPrice = 'fixedPrice',
  HourlyRate = 'hourlyRate',
  Subscription = 'subscription',
  Offer = 'offer'
}

export enum ProbabilityOption {
  _t = 'projects.forecast.probabilityOption',
  Hide = 'hide',
  Show = 'show',
  ShowAndCalculate = 'showAndCalculate'
}

export enum ProductSaleLinesGroupByOption {
  _t = 'invoicingPreferences.attributes.productSaleLinesGroupByOption.options',
  None = 'none',
  Product = 'product',
  ProjectExtension = 'projectExtension',
  Task = 'task'
}

export enum ProfitFactor {
  _t = 'projects.profitFactor',
  None = 'none',
  Calculated = 'calculated',
  Fixed = 'fixed',
  IncomeToCost = 'incomeToCost'
}

export enum ProjectBudgetMonthlyGroupingOption {
  _t = 'overviewReport.groupByOption',
  Project = 'project',
  Customer = 'customer',
  PriceModel = 'priceModel'
}

export enum ProjectExtensionGroupByOption {
  _t = 'projects.projectExtension.overviewReport.projectExtensionGroupByOption',
  None = 'none',
  Project = 'project',
  PriceDefinition = 'priceDefinition',
  Customer = 'customer',
  Status = 'status',
  ProjectOwner = 'projectOwner',
  Department = 'department',
  ProjectState = 'projectState',
  TagGroup0 = 'tagGroup0',
  TagGroup1 = 'tagGroup1',
  TagGroup2 = 'tagGroup2',
  TagGroup3 = 'tagGroup3',
  TagGroup4 = 'tagGroup4'
}

export enum ProjectExtensionOrderByOption {
  _t = 'projects.projectExtension.overviewReport.projectExtensionOrderByOption',
  None = 'none',
  ProjectNumberAsc = 'projectNumberAsc',
  ProjectNumberDesc = 'projectNumberDesc',
  ProjectNameAsc = 'projectNameAsc',
  ProjectNameDesc = 'projectNameDesc',
  ProjectExtensionNumberAsc = 'projectExtensionNumberAsc',
  ProjectExtensionNumberDesc = 'projectExtensionNumberDesc',
  CustomerNameAsc = 'customerNameAsc',
  CustomerNameDesc = 'customerNameDesc',
  CustomerNumberAsc = 'customerNumberAsc',
  CustomerNumberDesc = 'customerNumberDesc',
  EstimatedMinutesAsc = 'estimatedMinutesAsc',
  EstimatedMinutesDesc = 'estimatedMinutesDesc',
  TotalPriceShareAsc = 'totalPriceShareAsc',
  TotalPriceShareDesc = 'totalPriceShareDesc',
  EstimatedCostAsc = 'estimatedCostAsc',
  EstimatedCostDesc = 'estimatedCostDesc',
  EstimatedIncomeAsc = 'estimatedIncomeAsc',
  EstimatedIncomeDesc = 'estimatedIncomeDesc',
  EstimatedProfitAsc = 'estimatedProfitAsc',
  EstimatedProfitDesc = 'estimatedProfitDesc',
  EstimatedProfitPercentageAsc = 'estimatedProfitPercentageAsc',
  EstimatedProfitPercentageDesc = 'estimatedProfitPercentageDesc'
}

export enum ProjectExtensionState {
  _t = 'projects.extensions.projectExtensionStates',
  NotStarted = 'notStarted',
  InProgress = 'inProgress',
  Finished = 'finished'
}

export enum ProjectMembershipRolePermission {
  _t = 'projectMembershipRoles.permissionEnum',
  ProjectManager = 'projectManager',
  Member = 'member',
  None = 'none'
}

export enum ProjectMembershipRoleState {
  _t = 'projectMembershipRoles.stateEnum',
  Active = 'active',
  Passive = 'passive'
}

export enum ProjectMembershipRoleType {
  _t = 'projectMembershipRoles.roleType',
  Global = 'global',
  Customer = 'customer'
}

export enum ProjectMembershipState {
  _t = 'projectMembershipRoles.stateEnum',
  Active = 'active',
  Passive = 'passive'
}

export enum ProjectMoveType {
  _t = 'users.moveToOtherCompany.projectMoveType',
  All = 'all',
  OnlyActive = 'onlyActive',
  None = 'none'
}

export enum ProjectParticipantCompanyType {
  _t = 'reviews.overview.reviews.projectParticipantCompanyType',
  Customer = 'Customer',
  Subcontractor = 'Subcontractor',
  Supplier = 'Supplier',
  Owner = 'Owner'
}

export enum ProjectState {
  _t = 'projects.projectState',
  Offer = 'offer',
  OfferRejected = 'offerRejected',
  NotStarted = 'notStarted',
  InProgress = 'inProgress',
  Stopped = 'stopped',
  Finished = 'finished'
}

export enum ProjectsDefaultCurrencyOption {
  _t = 'preferences.projects.projectsDefaultCurrencyOptions',
  Customer = 'customer',
  Predefined = 'predefined'
}

export enum RequestEntityType {
  _t = 'scriveDocument.requestEntityType',
  Offer = 'offer'
}

export enum RequestSource {
  _t = 'scriveDocument.requestSource',
  Offer = 'offer'
}

export enum ResourcePlannerGroupBy {
  _t = 'availabilityView.monthly.groupBy',
  User = 'user',
  Role = 'role'
}

export enum ResponseStatus {
  _t = 'integrations.calendarImport',
  Accepted = 'accepted',
  Tentative = 'tentative',
  Declined = 'declined',
  NotResponded = 'notResponded'
}

export enum ResponsibilityType {
  _t = 'users.mainPage.userDetails.projectPlan.hrOverview',
  Manager = 'manager',
  TimesheetApprover = 'timesheetApprover',
  TravelExpenseApprover = 'travelExpenseApprover',
  AbsenceApprover = 'absenceApprover'
}

export enum RiskGroupByOption {
  _t = 'risk.overviewReport.riskGroupByOption',
  None = 'none',
  CreatedUserAccount = 'createdUserAccount',
  Project = 'project',
  TagGroup0 = 'tagGroup0',
  TagGroup1 = 'tagGroup1',
  TagGroup2 = 'tagGroup2',
  TagGroup3 = 'tagGroup3',
  TagGroup4 = 'tagGroup4'
}

export enum RiskOrderByOption {
  _t = 'risk.overviewReport.riskOrderByOption',
  None = 'none',
  CreatedUserAccountNameAsc = 'createdUserAccountNameAsc',
  CreatedUserAccountNameDesc = 'createdUserAccountNameDesc',
  ProjectNameAsc = 'projectNameAsc',
  ProjectNameDesc = 'projectNameDesc',
  ProjectNumberAsc = 'projectNumberAsc',
  ProjectNumberDesc = 'projectNumberDesc'
}

export enum SalaryCostEstimationOption {
  _t = 'preferences.projects.projectPlan.salaryCostEstimation',
  Salary = 'salary',
  Role = 'role'
}

export enum ScheduledJobCron {
  _t = 'entities.scheduledReportJobDto.scheduledJobCron',
  FirstDayInMonth = 'firstDayInMonth',
  TenthDayInMonth = 'tenthDayInMonth',
  FifteenthDayInMonth = 'fifteenthDayInMonth',
  TwentiethDayInMonth = 'twentiethDayInMonth',
  LastDayInMonth = 'lastDayInMonth'
}

export enum Scope {
  _t = 'preferences.scope',
  Global = 'global',
  Company = 'company',
  User = 'user'
}

export enum ScriveAuthenticationMethod {
  _t = 'integrations.scrive.authenticationMethod',
  Standard = 'standard',
  DkMitid = 'dk_mitid',
  NoBankid = 'no_bankid',
  SeBankid = 'se_bankid'
}

export enum ScriveParticipantRole {
  _t = 'scriveDocumentParticipant.participantRole',
  Viewer = 'viewer',
  SigningParty = 'signing_party',
  Approver = 'approver',
  HiddenApprover = 'hidden_approver'
}

export enum SendingInvoiceMethodType {
  _t = 'customers.index.preferredSendingInvoiceMethodType',
  Email = 'email',
  Ehf = 'ehf',
  Paper = 'paper'
}

export enum SeverityLevel {
  _t = 'SeverityLevel',
  Ok = 'ok',
  Low = 'low',
  Medium = 'medium',
  High = 'high'
}

export enum SourceSystem {
  _t = 'integrations.calendarImport',
  Apple = 'apple',
  Google = 'google',
  Outlook = 'outlook',
  Slack = 'slack'
}

export enum Sparebank1Bank {
  _t = 'integrations.listview.views.softrig.sparebank1',
  Gudbransdal = 'Gudbransdal',
  HallingdalValdres = 'Hallingdal_Valdres',
  LomOgSkjak = 'Lom_og_Skjak',
  NordNorge = 'Nord_Norge',
  RingerikeHadeland = 'Ringerike_Hadeland',
  SrBank = 'SR_Bank',
  OstfoldAkershus = 'Ostfold_Akershus',
  Ostlandet = 'Ostlandet'
}

export enum SuggestedProjectsPastInterval {
  _t = 'preferences.projects.suggestedProjectsPastIntervalOption',
  None = 'none',
  OneWeek = 'oneWeek',
  OneMonth = 'oneMonth',
  TwoMonths = 'twoMonths',
  ThreeMonths = 'threeMonths',
  SixMonths = 'sixMonths',
  TwelveMonths = 'twelveMonths'
}

export enum SupportAccessRequestStatus {
  _t = 'supportAccess.requestStatus',
  Granted = 'GRANTED',
  Requested = 'REQUESTED',
  AlreadyRequested = 'ALREADY_REQUESTED'
}

export enum SupportAccessStatus {
  _t = 'supportAccess.status',
  Granted = 'GRANTED',
  Requested = 'REQUESTED',
  None = 'NONE'
}

export enum TagCopyStrategy {
  _t = 'tagGroups.tagCopyStrategy',
  Copy = 'copy',
  NoCopy = 'noCopy',
  ResetSortOrder = 'resetSortOrder'
}

export enum TagOperator {
  _t = 'tagGroups.tagOperator',
  And = 'and',
  Or = 'or'
}

export enum TagRule {
  _t = 'tagGroups.tagRules',
  NotRequired = 'notRequired',
  RequiredOnlyOne = 'requiredOnlyOne',
  RequiredOneOrMore = 'requiredOneOrMore',
  Disabled = 'disabled'
}

export enum TagType {
  _t = 'tagGroups.defaults',
  Project = 'project',
  UserAccount = 'userAccount',
  Customer = 'customer',
  ProjectExtension = 'projectExtension',
  TimeRecord = 'timeRecord',
  CloudFile = 'cloudFile',
  Task = 'task',
  Invoice = 'invoice',
  Milestone = 'milestone',
  Offer = 'offer',
  ProjectIncomingEmail = 'projectIncomingEmail',
  Contact = 'contact',
  WorkingDay = 'workingDay',
  Nonconformity = 'nonconformity',
  Checklist = 'checklist',
  Routine = 'routine',
  Risk = 'risk',
  ProjectMembership = 'projectMembership',
  ProjectTemplate = 'projectTemplate',
  ProjectExtensionTemplate = 'projectExtensionTemplate',
  OfferProjectExtensionLine = 'offerProjectExtensionLine',
  OfferTaskLine = 'offerTaskLine',
  TaskSchedule = 'taskSchedule'
}

export enum TaskScheduleCopyTagOption {
  _t = 'tasks.taskSchedule.settings.copyTagOption',
  DontCopy = 'dontCopy',
  CopyFromTemplate = 'copyFromTemplate',
  Predefined = 'predefined'
}

export enum TaskScheduleFrequencyOption {
  _t = 'tasks.taskSchedule.frequencyOption',
  Week = 'week',
  Month = 'month',
  ExactMonths = 'exactMonths',
  IrregularMonths = 'irregularMonths'
}

export enum TaskScheduleMoveDueDateOption {
  _t = 'tasks.taskSchedule.moveDueDateOption',
  DontMove = 'dontMove',
  PreviousWorkingDay = 'previousWorkingDay',
  NextWorkingDay = 'nextWorkingDay'
}

export enum TaskState {
  _t = 'tasks.taskStates',
  Open = 'open',
  Closed = 'closed'
}

export enum TeamMembers {
  _t = 'projects.overview.teamMembers',
  Assigned = 'assigned',
  NotAssigned = 'notAssigned'
}

export enum TimeRecordsGroupByOption {
  _t = 'hours.overview.timeRecordsGroupByOption',
  None = 'none',
  UserAccount = 'userAccount',
  Customer = 'customer',
  Project = 'project',
  ProjectExtension = 'projectExtension',
  PriceDefinition = 'priceDefinition',
  Task = 'task',
  ProjectMembershipRole = 'projectMembershipRole',
  ProjectCurrencyCode = 'projectCurrencyCode',
  Year = 'year',
  Month = 'month',
  Week = 'week',
  Day = 'day',
  InvoicedState = 'invoicedState',
  Department = 'department',
  Invoice = 'invoice',
  InvoiceMonth = 'invoiceMonth',
  DelayedInvoicingUntilDateMonth = 'delayedInvoicingUntilDateMonth',
  ProjectManager = 'projectManager',
  ProjectOwner = 'projectOwner',
  TagGroup0 = 'tagGroup0',
  TagGroup1 = 'tagGroup1',
  TagGroup2 = 'tagGroup2',
  TagGroup3 = 'tagGroup3',
  TagGroup4 = 'tagGroup4'
}

export enum TimeRecordsOrderByOption {
  _t = 'hours.overview.timeRecordsOrderByOption',
  None = 'none',
  TimeRecordDateAsc = 'timeRecordDateAsc',
  TimeRecordDateDesc = 'timeRecordDateDesc',
  UserAccountName = 'userAccountName',
  ProjectName = 'projectName',
  ProjectNumber = 'projectNumber',
  ProjectExtensionName = 'projectExtensionName',
  CustomerName = 'customerName',
  CustomerNumber = 'customerNumber',
  OvertimeCategoryName = 'overtimeCategoryName',
  InvoicedState = 'invoicedState',
  DelayedInvoicingUntilDate = 'delayedInvoicingUntilDate',
  Description = 'description',
  MinutesAsc = 'minutesAsc',
  MinutesDesc = 'minutesDesc',
  BillableMinutesAsc = 'billableMinutesAsc',
  BillableMinutesDesc = 'billableMinutesDesc',
  UserAccountTotalSalaryCostTotalAsc = 'userAccountTotalSalaryCostTotalAsc',
  UserAccountTotalSalaryCostTotalDesc = 'userAccountTotalSalaryCostTotalDesc',
  AverageHourlyRateAsc = 'averageHourlyRateAsc',
  AverageHourlyRateDesc = 'averageHourlyRateDesc'
}

export enum TransferState {
  _t = 'export.transferState',
  ToTransfer = 'toTransfer',
  Transferring = 'transferring',
  Transferred = 'transferred',
  DoNotTransfer = 'doNotTransfer'
}

export enum TravelPeriodSetup {
  _t = 'travel.periodSetup',
  No2024 = 'NO_2024',
  No2025 = 'NO_2025',
  No2026 = 'NO_2026'
}

export enum UserAccountDepartmentOption {
  _t = 'ipaas.config.userAccountDepartment',
  NoDepartment = 'noDepartment',
  DepartmentAsEntity = 'departmentAsEntity',
  DepartmentByTag = 'departmentByTag'
}

export enum VspOrganizationalUnit {
  _t = 'integrations.vsp.organizationalUnit',
  OrganizationalUnit1 = 'OrganizationalUnit1',
  OrganizationalUnit2 = 'OrganizationalUnit2',
  OrganizationalUnit3 = 'OrganizationalUnit3',
  OrganizationalUnit4 = 'OrganizationalUnit4',
  OrganizationalUnit5 = 'OrganizationalUnit5',
  OrganizationalUnit6 = 'OrganizationalUnit6',
  OrganizationalUnit7 = 'OrganizationalUnit7',
  OrganizationalUnit8 = 'OrganizationalUnit8',
  OrganizationalUnit9 = 'OrganizationalUnit9',
  OrganizationalUnit10 = 'OrganizationalUnit10',
  OrganizationalUnit11 = 'OrganizationalUnit11',
  OrganizationalUnit12 = 'OrganizationalUnit12'
}

export enum WhoCanEditBillableTimeOption {
  _t = 'preferences.users.whoCanEditBillableTimeOption',
  Administrators = 'administrators',
  ProjectOwnersAndAdministrators = 'projectOwnersAndAdministrators',
  ProjectMembersAndProjectOwnersAndAdministrators = 'projectMembersAndProjectOwnersAndAdministrators'
}
